/**
 * Nocturne delivery estimate: <nocturne-eta data-min="3" data-max="7"> turns its [data-eta] text
 * ("en 3 à 7 jours ouvrés", the fallback) into real dates — "entre le jeu. 6 et le mer. 12 nov." —
 * counted in working days from today, skipping weekends and French public holidays.
 */
(() => {
  if (customElements.get('nocturne-eta')) return;

  const DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  const MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const key = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  const holidaysByYear = {};

  function holidays(year) {
    if (holidaysByYear[year]) return holidaysByYear[year];
    // Easter Sunday (anonymous Gregorian algorithm) gives Easter Monday, Ascension and Whit Monday.
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const h = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30;
    const l = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - h - (c % 4)) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const dates = [[0, 1], [4, 1], [4, 8], [6, 14], [7, 15], [10, 1], [10, 11], [11, 25]].map(([mo, d]) => new Date(year, mo, d));
    [1, 39, 50].forEach((n) => dates.push(new Date(year, month, day + n)));
    return (holidaysByYear[year] = new Set(dates.map(key)));
  }

  function addWorkingDays(from, count) {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (count > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() % 6 !== 0 && !holidays(d.getFullYear()).has(key(d))) count -= 1;
    }
    return d;
  }

  class NocturneEta extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector('[data-eta]');
      const min = Number(this.dataset.min);
      const max = Math.max(min, Number(this.dataset.max));
      if (!target || !min) return;
      const today = new Date();
      const from = addWorkingDays(today, min);
      const to = addWorkingDays(today, max);
      const sameMonth = from.getMonth() === to.getMonth();
      target.textContent = `entre le ${DAYS[from.getDay()]} ${from.getDate()}${sameMonth ? '' : ` ${MONTHS[from.getMonth()]}`} et le ${DAYS[to.getDay()]} ${to.getDate()} ${MONTHS[to.getMonth()]}`;
    }
  }

  customElements.define('nocturne-eta', NocturneEta);
})();
